import React from 'react';
import { Input, Dropdown, Button, Checkbox } from 'semantic-ui-react';
import { FeedCategory, FeedSource, FeedFilters } from '../../../models/feed';
import styles from './FilterPanel.module.scss';

interface FilterPanelProps {
    filters: FeedFilters;
    categories: FeedCategory[];
    sources: FeedSource[];
    onFilterChange: (filters: FeedFilters) => void;
    onClearFilters: () => void;
    showUpcomingOnly?: boolean;
    type: 'news' | 'event';
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
    filters,
    categories,
    sources,
    onFilterChange,
    onClearFilters,
    showUpcomingOnly = false,
    type,
}) => {
    const hasActiveFilters =
        filters.search ||
        filters.categoryId ||
        filters.sourceName ||
        filters.onlyUrgent ||
        (type === 'event' && !filters.onlyEvents);

    const categoryOptions = [
        { key: 'all', text: 'All Categories', value: '' },
        ...categories.map((cat) => ({
            key: cat.id,
            text: cat.displayName,
            value: cat.id,
        })),
    ];

    const sourceOptions = [
        { key: 'all', text: 'All Sources', value: '' },
        ...sources.map((source) => ({
            key: source.id,
            text: source.name,
            value: source.name,
        })),
    ];

    return (
        <div className={styles.filterPanel}>
            <div className={styles.filterRow}>
                <Input
                    icon="search"
                    placeholder="Search..."
                    value={filters.search || ''}
                    onChange={(e) =>
                        onFilterChange({ ...filters, search: e.target.value })
                    }
                    className={styles.searchInput}
                    aria-label="Search"
                />
                <Dropdown
                    selection
                    placeholder="Category"
                    options={categoryOptions}
                    value={filters.categoryId || ''}
                    onChange={(e, data) =>
                        onFilterChange({
                            ...filters,
                            categoryId: data.value as string,
                        })
                    }
                    className={styles.filterDropdown}
                    aria-label="Filter by category"
                />
                <Dropdown
                    selection
                    placeholder="Source"
                    options={sourceOptions}
                    value={filters.sourceName || ''}
                    onChange={(e, data) =>
                        onFilterChange({
                            ...filters,
                            sourceName: data.value as string,
                        })
                    }
                    className={styles.filterDropdown}
                    aria-label="Filter by source"
                />
                {type === 'event' && (
                    <Checkbox
                        label="Upcoming Only"
                        checked={filters.onlyEvents !== false}
                        onChange={(e, data) =>
                            onFilterChange({
                                ...filters,
                                onlyEvents: data.checked,
                            })
                        }
                        className={styles.checkboxFilter}
                        id="upcoming-only-checkbox"
                    />
                )}
                {hasActiveFilters && (
                    <Button onClick={onClearFilters} basic>
                        Clear Filters
                    </Button>
                )}
            </div>
        </div>
    );
};
